import {
    AwesomeTableComponent,
    IColumnsProps,
    InputTextSearch,
} from "d-react-components";
import { debounce, filter, map } from "lodash";
import { useContext, useMemo, useState } from "react";
import { StockAdjustmentDetailContext } from "../../../../context/stock-adjustment";
import Messages from "../../../../languages/Messages";
import ProductNameView from "../../../product/share/ProductNameView";

const StockAdjustmentItems = () => {
    const { stockAdjustment } = useContext(StockAdjustmentDetailContext);
    const [textSearch, setTextSearch] = useState<string>("");
    const proSource = useMemo(() => {
        const mappedPros = map(stockAdjustment?.products ?? [], (item) => ({
            ...(item?.product ?? {}),
            adjustment: item?.adjustment ?? 0,
        }));
        if (textSearch) {
            return filter(mappedPros, (item) => {
                const { name, sku } = item;
                const text = textSearch?.toLocaleLowerCase?.();
                return (
                    name?.toLocaleLowerCase?.()?.indexOf(text) !== -1 ||
                    sku?.toLocaleLowerCase?.()?.indexOf(text) !== -1
                );
            });
        }
        return mappedPros;
    }, [textSearch, stockAdjustment?.products]);

    const columns: IColumnsProps = [
        {
            title: Messages.item,
            dataIndex: "",
            render: (service) => <ProductNameView product={service} />,
        },
        {
            title: Messages.quantity,
            dataIndex: "adjustment",
        },
    ];

    const onChangeSearch = debounce((event) => {
        const search = event.target.value;
        setTextSearch(search);
    }, 0);

    return (
        <div className="mt-3">
            <div className="flex-row-between-center">
                <label>{Messages.service}</label>
            </div>
            <InputTextSearch onChange={onChangeSearch} className="mt-3" />
            <AwesomeTableComponent
                columns={columns}
                dataSource={proSource}
                className="mt-3"
                pagination={false}
            />
        </div>
    );
};

export default StockAdjustmentItems;
